module.exports = __webpack_public_path__ + "img/coin-use-1.621b3e54.jpg";